var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-btn",
        {
          staticClass: "mb-1",
          attrs: { width: "26px", height: "26px", icon: "" },
          on: {
            click: function ($event) {
              return _vm.deleteRow()
            },
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "icon-delete-21x21",
              staticStyle: { "font-size": "24px" },
            },
            [
              _c("span", {
                staticClass: "path1 letterSpacing0",
                staticStyle: { "margin-right": "-1px" },
              }),
              _c("span", { staticClass: "path2" }),
            ]
          ),
        ]
      ),
      _c(
        "v-btn",
        {
          staticClass: "mb-1",
          attrs: { width: "26px", height: "26px", icon: "" },
          on: { click: _vm.ignoreBtnClick },
        },
        [
          _c(
            "span",
            {
              staticClass: "icon-ignore-21x21",
              staticStyle: { "font-size": "24px" },
            },
            [
              _c("span", {
                staticClass: "path1 letterSpacing0",
                staticStyle: { "margin-right": "-1px" },
              }),
              _c("span", { staticClass: "path2" }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }